(() => {
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const cardFor = (review) => {
    const card = make("article", "ideal-showcase-card");
    const stars = make("span", "ideal-showcase-card__stars", `${"★".repeat(review.rating)}${"☆".repeat(5 - review.rating)}`);
    stars.setAttribute("aria-label", `Rated ${review.rating} out of 5`);
    card.append(stars, make("h3", "", review.title || "Customer review"), make("p", "ideal-showcase-card__body", review.body));
    const meta = make("div", "ideal-showcase-card__meta");
    meta.append(make("strong", "", review.displayName || "Anonymous"));
    if (review.verifiedPurchase) meta.append(make("span", "ideal-showcase-card__verified", "Verified purchase"));
    card.append(meta);
    if (review.productHandle) {
      const link = make("a", "ideal-showcase-card__product", review.productTitle || "View reviewed product");
      link.href = `/products/${encodeURIComponent(review.productHandle)}`;
      card.append(link);
    }
    return card;
  };
  const initialiseCarousel = (root, track) => {
    const controls = root.querySelector("[data-ideal-carousel-controls]");
    const previous = root.querySelector("[data-ideal-carousel-prev]");
    const next = root.querySelector("[data-ideal-carousel-next]");
    const position = root.querySelector("[data-ideal-carousel-position]");
    const cards = Array.from(track.children);
    if (!controls || !previous || !next || !position || root.dataset.mobileLayout !== "carousel" || cards.length < 2) return;

    controls.hidden = false;
    let activeIndex = 0;
    let ticking = false;
    const targetLeft = (card) => card.offsetLeft - track.offsetLeft;
    const updateControls = () => {
      activeIndex = cards.reduce((nearest, card, index) =>
        Math.abs(targetLeft(card) - track.scrollLeft) < Math.abs(targetLeft(cards[nearest]) - track.scrollLeft) ? index : nearest, 0);
      position.textContent = `Review ${activeIndex + 1} of ${cards.length}`;
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
      ticking = false;
    };
    const goTo = (index) => {
      const boundedIndex = Math.max(0, Math.min(cards.length - 1, index));
      track.scrollTo({ left: targetLeft(cards[boundedIndex]), behavior: "smooth" });
    };

    previous.addEventListener("click", () => goTo(activeIndex - 1));
    next.addEventListener("click", () => goTo(activeIndex + 1));
    track.addEventListener("scroll", () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateControls);
    }, { passive: true });
    window.addEventListener("resize", updateControls, { passive: true });
    updateControls();
  };
  const initialise = async (root) => {
    if (root.dataset.idealInitialised === "true") return;
    root.dataset.idealInitialised = "true";
    try {
      const minimumRating = Number(root.dataset.minimumRating || 1);
      const reviewCount = Number(root.dataset.reviewCount || 4);
      const endpoint = new URL(root.dataset.endpoint);
      if (minimumRating > 1) endpoint.searchParams.set("limit", "24");
      const response = await fetch(endpoint.toString(), { headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error(`Ideal Reviews returned ${response.status}`);
      const result = await response.json();
      let selectedReviews = result.reviews.filter((review) => review.rating >= minimumRating && review.rating <= 5);
      // Fill the showcase with recent eligible reviews, without changing the full review summary.
      let hasMore = result.hasMore;
      for (let page = 2; minimumRating > 1 && selectedReviews.length < reviewCount && hasMore && page <= 10; page += 1) {
        endpoint.searchParams.set("page", String(page));
        const nextResponse = await fetch(endpoint.toString(), { headers: { Accept: "application/json" } });
        if (!nextResponse.ok) break;
        const nextResult = await nextResponse.json();
        selectedReviews.push(...nextResult.reviews.filter((review) => review.rating >= minimumRating && review.rating <= 5));
        hasMore = nextResult.hasMore;
      }
      selectedReviews = selectedReviews.slice(0, reviewCount);
      const average = root.querySelector("[data-ideal-average]");
      const total = root.querySelector("[data-ideal-total]");
      const fiveStar = root.querySelector("[data-ideal-five-star]");
      if (average) average.textContent = Number(result.summary.averageRating).toFixed(1);
      if (total) total.textContent = `Based on ${Number(result.summary.total).toLocaleString("en-GB")} reviews`;
      if (fiveStar) fiveStar.textContent = `${Number(result.summary.distribution?.[5] || 0).toLocaleString("en-GB")} five-star reviews`;
      const cards = root.querySelector("[data-ideal-cards]");
      if (cards) {
        selectedReviews.forEach((review) => cards.append(cardFor(review)));
        initialiseCarousel(root, cards);
      }
      const status = root.querySelector("[data-ideal-status]");
      if (status) {
        const swipeable = root.dataset.mobileLayout === "carousel" && window.matchMedia("(max-width: 599px)").matches;
        status.textContent = selectedReviews.length
          ? swipeable
            ? `Use the arrows or swipe to browse ${selectedReviews.length} customer reviews`
            : `${selectedReviews.length} customer reviews shown`
          : "No matching reviews to show just now.";
      }
    } catch {
      root.dataset.idealInitialised = "false";
      const status = root.querySelector("[data-ideal-status]");
      if (status) status.textContent = "Customer reviews could not be loaded just now.";
    }
  };
  const initialiseAll = (scope = document) => scope.querySelectorAll("[data-ideal-reviews-showcase]").forEach(initialise);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialiseAll(), { once: true });
  else initialiseAll();
  document.addEventListener("shopify:section:load", (event) => initialiseAll(event.target));
})();
